module.exports = __webpack_public_path__ + "assets/img/23_127.2752bda4.jpg";